import { render, staticRenderFns } from "./MenuUpdateImporter.vue?vue&type=template&id=b8300dd0&scoped=true&"
import script from "./MenuUpdateImporter.vue?vue&type=script&lang=js&"
export * from "./MenuUpdateImporter.vue?vue&type=script&lang=js&"
import style0 from "./importer.css?vue&type=style&index=0&id=b8300dd0&scoped=true&lang=css&"
import style1 from "./MenuUpdateImporter.vue?vue&type=style&index=1&id=b8300dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8300dd0",
  null
  
)

export default component.exports